@import '~style-sheet-helpers/core.less';

.main-content {
  overflow: hidden;
}

.batches-page-wrappers {
  height: 100%;
  width: 200%;
  display: flex;
  transition: all 300ms ease;

  &.detail-page-in {
    transform: translateX(-50%);
  }
}

.list-page {
  width: 50%;
}

.detail-page {
  width: 50%;
}

.open-batch-details-page {
  height: 100%;
  width: 100%;
}
